import { KeplerAggregationType } from './kepler-types'

export enum PopupEvent {
  Hover = 'hover',
  Click = 'click'
}

export enum PopupStyle {
  Light = 'light',
  LightWithHiFirst = 'lightWithHiFirst',
  Dark = 'dark',
  DarkWithHiFirst = 'darkWithHiFirst',
  Panel = 'panel',
  None = 'none'
}

export interface PopupField {
  name: string
  customName?: string
  isExpression?: boolean
  format?: string
  spatialIndexAggregation?: KeplerAggregationType
}

export interface PopupFormatSettings {
  fields: PopupField[]
  style: PopupStyle
  templateMode?: boolean
  template?: string
  templateEdited?: boolean
}

export interface LayerPopupSettings {
  enabled?: boolean
  [PopupEvent.Hover]?: PopupFormatSettings
  [PopupEvent.Click]?: PopupFormatSettings
}

export interface PopupSettings {
  layers: Record<string, LayerPopupSettings>
  coordinates?: boolean
  comparison?: string
}
